import React from 'react';

import {ChemSearchSubmit} from 'chemistry/chemSearchSubmit';
import {isReactionChemSearch, ToggleHighlightParams} from 'chemistry/ChemSearchUtils';
import MoleculeChemSearchModal from 'chemistry/MoleculeChemSearchModal';
import ReactionChemSearchModal from 'chemistry/ReactionChemSearchModal';
import {SearchParams} from 'search/SearchConstants';

export interface ChemSearchModalProps {
  initialMol: string | null;
  onRequestSubmit: (submit: ChemSearchSubmit | null) => void;
  onRequestClose: () => void;
  toggleHighlightParams: ToggleHighlightParams;
  searchParams: SearchParams;
}

export default function ChemSearchModal(props: ChemSearchModalProps): JSX.Element {
  return isReactionChemSearch(props.searchParams) ? (
    <ReactionChemSearchModal {...props} />
  ) : (
    <MoleculeChemSearchModal {...props} />
  );
}
